import { render, staticRenderFns } from "./TagSource.vue?vue&type=template&id=cb1ade70&scoped=true&"
import script from "./TagSource.vue?vue&type=script&lang=js&"
export * from "./TagSource.vue?vue&type=script&lang=js&"
import style0 from "./TagSource.vue?vue&type=style&index=0&id=cb1ade70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ade70",
  null
  
)

export default component.exports